module.exports = __webpack_public_path__ + "static/img/DEV2-CT-gIGRl.459c8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DEV2-CT-gIGRl.png
// module id = C8Nr
// module chunks = 16